import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import { Box, Toolbar } from '@mui/material';
import Container from '@mui/material/Container';

import Logo from './Logo';

export default function HeaderShell({children}) {
    return (
        <AppBar position="static" sx={{ boxShadow: 0, backgroundColor: "#fff" }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters sx={{ justifyContent: "space-between", alignItems: "center" }}>
                    <Logo />
                    {children}
                </Toolbar>
            </Container>
        </AppBar>
    )
}